import { createStore, applyMiddleware } from 'redux';
import rootReducer from '../reducers/index';
import thunk from 'redux-thunk';

// @ts-ignore
import { seamlessImmutableReconciler, seamlessImmutableTransformCreator } from 'redux-persist-seamless-immutable';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import initialState from 'redhotpie-shared-lib/reducers/initialState'; // defaults to localStorage for web and AsyncStorage for react-native

const transformerConfig = {
  whitelistPerReducer: {
    // "eventReducer": ["filtersEventSearch", "defaultFiltersEventSearch", "isGetUserSearchSetting"]
  },
};

const persistConfig = {
  key: 'rhp-root',
  storage,
  stateReconciler: seamlessImmutableReconciler,
  // blacklist: ["ajaxCallsInProgress", "screen", "appStateReducer"],
  whitelist: [
    'loginReducer',
    // "eventReducer"
  ],
  transforms: [seamlessImmutableTransformCreator(transformerConfig)],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default function configureStore(initState) {
  const store = createStore(persistedReducer, initState, applyMiddleware(thunk));

  const persistor = persistStore(store);
  return { store, persistor };
}
